import { buildQuoteText, buildQuoteHtml } from './share-text'

/** 选区短于这个字数不追加署名，避免复制一个词也被污染 */
export const MIN_QUOTE_CHARS = 20

const toElement = (node) => (node && node.nodeType === 3 ? node.parentElement : node)

/**
 * 从当前选区解析「要追加署名的引用」；不满足条件（无选区 / 不在某张卡的正文里 / 太短）返回 null。
 * 正文容器是 Container.js 的 <article class="note_article">，外层 .container[note_id] 挂着卡片 id 与 data-note-title；
 * 宽屏多列同时渲染多张卡，选区跨卡时 commonAncestorContainer 落在 .note_article 之外 → 不干预。
 */
export const quoteFromSelection = (sel) => {
    if (!sel || sel.isCollapsed || sel.rangeCount === 0) return null
    const range = sel.getRangeAt(0)
    const el = toElement(range.commonAncestorContainer)
    const article = el && el.closest ? el.closest('.note_article') : null
    if (!article) return null
    const container = article.closest('.container[note_id]')
    const id = container && container.getAttribute('note_id')
    if (!id) return null
    const text = sel.toString()
    if (text.trim().length < MIN_QUOTE_CHARS) return null
    const holder = document.createElement('div')
    holder.appendChild(range.cloneContents())
    return { text, html: holder.innerHTML, card: { id, title: container.getAttribute('data-note-title') || '' } }
}

const onCopy = (e) => {
    try {
        if (!e.clipboardData) return
        const q = quoteFromSelection(window.getSelection())
        if (!q) return
        e.clipboardData.setData('text/plain', buildQuoteText(q.text, q.card))
        e.clipboardData.setData('text/html', buildQuoteHtml(q.html, q.card))
        e.preventDefault()
    } catch (error) {
        // 任何异常都退回浏览器默认复制
        console.warn('[copy-attribution]', error)
    }
}

/** 全站只装一次（Post.js 挂载时），返回卸载函数 */
export const installCopyAttribution = () => {
    document.addEventListener('copy', onCopy)
    return () => document.removeEventListener('copy', onCopy)
}
